import { defineComponent as _defineComponent } from 'vue'
import { Button } from '@tencent/wphk-design';
import { computed } from 'vue';
import { BannerStatus } from '../hooks/use-vitasoy-lottery';
import { getPromotionDateText, LICENSE_DISPLAY_TEXT, LOTTERY_BANNER } from '../config';

/**
 * Banner 组件 Props
 */
interface LotteryBannerProps {
  /** Banner 状态 (ongoing/ended/won) */
  status?: BannerStatus;
  /** cdkey 是否存在 (1-有, 0-无) */
  hasCdkey?: string;
}

type EmitFn = (e: 'click') => void;

export default /*#__PURE__*/_defineComponent({
  __name: 'lottery-banner',
  props: {
    status: null,
    hasCdkey: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ((e: 'click') => void), expose: any, slots: any, attrs: any }) {

const props = __props as { status?: BannerStatus, hasCdkey?: string }


/** 推广日期文案（从配置动态获取） */
const promotionDateText = computed(() => getPromotionDateText());
const isEnd = computed(() => props.status === BannerStatus.Ended);
/**
 * 事件定义
 */



/**
 * 按钮文案 (根据状态计算)
 */
const computedButtonText = computed(() => {
  switch (props.status) {
    case BannerStatus.Ended:
      return '已結束';
    case BannerStatus.Won:
      return '我的優惠券';
    default:
      return '活動詳情';
  }
});

/**
 * Banner 图片映射
 */
const bannerImage = LOTTERY_BANNER;

/**
 * 按钮点击处理
 */
const onClickButton = () => {
  emit('click');
};

return { __sfc: true,props, promotionDateText, isEnd, emit, computedButtonText, bannerImage, onClickButton, Button, LICENSE_DISPLAY_TEXT }
}

})